import { z } from 'zod';

import { ExternalLoanIdRecordId, ExternalLoanIdValue, LosId } from '../../BrandedIds';
import { ExternalLoanIdType } from '../../loan/ExternalLoanIdRecord';
import { zodTemporalInstant } from '../../Temporal';

export const ExportableExternalLoanId = z
  .object({
    loanId: LosId.describe('The loan this external ID belongs to.'),
    id: ExternalLoanIdRecordId.describe(
      'Stable internal record identifier. This is the database primary key for the external loan ID record, not the external ID value itself.',
    ),

    type: ExternalLoanIdType.describe('The kind of external identifier (e.g. MERS MIN, investor loan number).'),
    value: ExternalLoanIdValue.describe('The external identifier value.'),

    createdAt: zodTemporalInstant,
    updatedAt: zodTemporalInstant,

    // Instants, not plain dates: the source columns are timestamps and as-of-date
    // consumers compare against them with <=, so export the exact stored moment.
    startDate: zodTemporalInstant
      .optional()
      .describe('When this external ID became effective for the loan (typically the first of a month).'),
    soldDate: zodTemporalInstant
      .optional()
      .describe('When ownership changed hands; unset means the ID is still current.'),
  })
  .meta({ title: 'ExternalLoanId' });
export type ExportableExternalLoanId = z.infer<typeof ExportableExternalLoanId>;
